import { render } from "./QuantidadeNovosPagantesDiaChart.vue?vue&type=template&id=2607ecc5"
import script from "./QuantidadeNovosPagantesDiaChart.vue?vue&type=script&lang=js"
export * from "./QuantidadeNovosPagantesDiaChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__